import { render, staticRenderFns } from "./VueSb.vue?vue&type=template&id=3a59b0a8&scoped=true&"
import script from "./VueSb.vue?vue&type=script&lang=js&"
export * from "./VueSb.vue?vue&type=script&lang=js&"
import style0 from "./VueSb.vue?vue&type=style&index=0&id=3a59b0a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59b0a8",
  null
  
)

export default component.exports